<!--Main Grid 2 cols-->
<div class="ad-SubMenu">
	<label>Calendar Type:</label>
	<select class="form-control" name="CalendarTypeID" [(ngModel)]="CalendarTypeID">
		<option value="" style="display: none"></option>
		<option *ngFor="let o of lstCalendarType" [ngValue]="o.CalendarTypeID">
			{{ o.CalendarTypeDesc }}
		</option>
	</select>

	<label for="SkipClosedDay">Skip Closed Day:</label>
	<input id="SkipClosedDay" [(ngModel)]="SkipClosedDay" class="form-control" type="checkbox" />

	<label for="UseSchoolBellSchedule">School Day Bell Schedule</label>
	<input id="UseSchoolBellSchedule" [(ngModel)]="UseSchoolBellSchedule" class="form-control" type="checkbox" />

	<label>Start Date:</label>
	<p-calendar
		[(ngModel)]="StartDate"
		showIcon="true"
		showButtonBar="true"
		[ngClass]="{ CenterText: true, WindowSize: LargerWindow == true }"
		(onShow)="onCalendarGrow()"
		(onClose)="onCalendarShrink()"
	></p-calendar>
</div>

<!--Buttons-->
<div class="ad-Buttons">
	<button class="btn btn-primary" (click)="onUpdate()">Update</button>
	<button class="btn btn-primary" (click)="onClose()">Close</button>
</div>
